export default __webpack_public_path__ + "static/media/termsBackground.0396669c.png";